/**
 * Seasonal marketing banner constants.
 *
 * Mirrors backend SeasonalBannerConstants so admin forms stay aligned with
 * API validation limits.
 */

/** Public DTO source when the active banner is a holiday event type. */
export const SEASONAL_BANNER_SOURCE_HOLIDAY = 'holiday' as const;

/** Public DTO source when the active banner is the evergreen AppSettings fallback. */
export const SEASONAL_BANNER_SOURCE_EVERGREEN = 'evergreen' as const;

/** Union of public banner source values. */
export type SeasonalBannerSource =
  | typeof SEASONAL_BANNER_SOURCE_HOLIDAY
  | typeof SEASONAL_BANNER_SOURCE_EVERGREEN;

/** Minimum lead days before the event date the holiday banner may appear. */
export const SEASONAL_BANNER_LEAD_DAYS_MIN = 1;

/** Maximum lead days before the event date the holiday banner may appear. */
export const SEASONAL_BANNER_LEAD_DAYS_MAX = 60;

/** Default lead days when an event type has not been configured. */
export const SEASONAL_BANNER_LEAD_DAYS_DEFAULT = 14;

/** Maximum length for seasonal banner headline text. */
export const SEASONAL_BANNER_HEADLINE_MAX_LENGTH = 100;

/** Maximum length for seasonal banner subtext. */
export const SEASONAL_BANNER_SUBTEXT_MAX_LENGTH = 160;

/** Maximum upload size for banner images (2 MB). */
export const SEASONAL_BANNER_MAX_UPLOAD_BYTES = 2 * 1024 * 1024;

/** Accepted MIME types for seasonal banner image uploads. */
export const SEASONAL_BANNER_ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

/** File input accept attribute for seasonal banner uploads. */
export const SEASONAL_BANNER_FILE_ACCEPT = '.jpg,.jpeg,.png,.webp';

/** Default Mantine color for the evergreen banner when unset. */
export const SEASONAL_BANNER_DEFAULT_COLOR = 'indigo';

/** Default CTA route for the evergreen banner when unset. */
export const SEASONAL_BANNER_DEFAULT_CTA_ROUTE = '/cards';
